var _clipPath;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgProfileImg(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 92 93",
    xmlns: "http://www.w3.org/2000/svg",
    xmlSpace: "preserve",
    style: {
      fillRule: "evenodd",
      clipRule: "evenodd",
      strokeLinejoin: "round",
      strokeMiterlimit: 2
    },
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    transform: "translate(-734 -259)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M780 259c25.405 0 46 20.595 46 46s-20.595 46-46 46-46-20.595-46-46 20.595-46 46-46Z",
    style: {
      fill: "#d73a1f"
    }
  }), _clipPath || (_clipPath = /*#__PURE__*/React.createElement("clipPath", {
    id: "a"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M780 259c25.405 0 46 20.595 46 46s-20.595 46-46 46-46-20.595-46-46 20.595-46 46-46Z"
  }))), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#a)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M822.29 353h-83.839c.416-5.868 4.611-16.122 9.098-17.968l4.816-1.427 12.308-7.487c-.031-1.026.07-1.734.357-2.317l6.065-1.961-.357-1.605a20115.26 20115.26 0 0 1-3.032-6.774l-1.427-5.526v-.357l-1.249-.356c-.893-1.225-2.308-5.302-1.605-7.131l1.07-.891c.293-.666-.871-5.584-.535-7.488.966-5.483 3.473-9.7 7.492-12.122 9.149-5.515 22.668-.349 24.795 8.2.847 3.408.353 7.104.178 10.34-.059 1.087.804 1.243 1.07 1.961 1.16 3.127-.853 6.121-2.854 6.952-.139 6.21-3.678 8.824-3.746 14.797h.357l5.351 2.139.892 2.318 6.6 4.456c7.044 4.211 17.736 11.561 18.195 22.247Z",
    style: {
      fill: "#f5f5f5",
      fillOpacity: 1
    }
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgProfileImg);
export default __webpack_public_path__ + "static/media/profile-img.0aaff136acaa9a97a2d24e5f904aa025.svg";
export { ForwardRef as ReactComponent };